// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getContractProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetContractProfessionalApi = createAsyncThunk(
  "hitGetContractProfessionalApi",
  async (jobId) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: {
            jobId: jobId
          //search,
        },
      };
      const url = ApiBaseUrl + getContractProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetContractProfessionalSlice = createSlice({
  name: "getContractProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetContractData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetContractProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetContractProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetContractProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetContractData } = GetContractProfessionalSlice.actions;
export default GetContractProfessionalSlice.reducer;
